var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConditionsFilled = function SvgConditionsFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.224 5.125c-2.06-2.06-5.44-2.03-7.537.068l-.817.817-.818-.817c-2.095-2.095-5.477-2.127-7.534-.068-1.64 1.64-1.992 4.233-.855 6.305.02.035.042.067.07.097l2.94 3.215 5.85 5.84a.496.496 0 0 0 .352.145c.127 0 .255-.05.352-.145l7.932-7.92c2.095-2.095 2.125-5.477.068-7.537h-.003Zm-8.707 7.89-1.952-1.953a.501.501 0 0 1 .707-.707l1.598 1.597 3.554-3.554a.5.5 0 0 1 .708.707l-3.91 3.91a.498.498 0 0 1-.705 0Z",
    fill: "currentColor"
  })));
};
export default SvgConditionsFilled;